// `Symbol.patternMatch` well-known symbol
// https://github.com/tc39/proposal-using-statement
require('../internals/define-well-known-symbol')('dispose');



//////////////////
// WEBPACK FOOTER
// ./node_modules/@firebase/polyfill/node_modules/core-js/modules/esnext.symbol.dispose.js
// module id = 1938
// module chunks = 0